import { render, staticRenderFns } from "./TekrarGonderDosyaEkle.vue?vue&type=template&id=0dc28d44&scoped=true&"
import script from "./TekrarGonderDosyaEkle.vue?vue&type=script&lang=js&"
export * from "./TekrarGonderDosyaEkle.vue?vue&type=script&lang=js&"
import style0 from "./TekrarGonderDosyaEkle.vue?vue&type=style&index=0&id=0dc28d44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc28d44",
  null
  
)

export default component.exports